import React, { useContext, useRef } from 'react'
import {dataContext,localestr,itemToText} from '../utils.js'
import Edit from '../cmp/Edit'
import icon from '../icons.svg'

function ServGrpDoc({data=undefined,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    //const getData=context.getData
    //const updateData=context.updateData
    const loaddata=context.loaddata
    const msg=context.msg
    const urAdmin=parseInt((context.user||{}).urAdmin||0)

    const targetRef=useRef()

    const checkAll=(val)=>{
        if(wndData.run) return
        let list=wndData.list.map(el=>{return {...el,checked:val}})
        setWndData({...wndData,list,checked:val,start:-1})
    }

    const checkItem=(idx,val)=>{
        if(wndData.run) return
        let list=[...wndData.list]
        list[idx].checked=val
        setWndData({...wndData,list,start:-1})
    }

    const chOper=(d)=>{
        if(wndData.run) return
        setWndData({...wndData,oper:d})
    }

    const run=()=>{
        //Тут доробити для групового друку
        if(wndData.run) {
            setWndData({...wndData,start:-1,run:false})
        }
        else if(wndData.oper){
            if(!urAdmin && parseInt(wndData.oper)===2){
                msg(localestr('Не достатньо прав для відміни проведення'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                return
            }
            if(!urAdmin && parseInt(wndData.oper)===3){
                msg(localestr('Не достатньо прав для позначення на знищення'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                return
            }
            if(!urAdmin && parseInt(wndData.oper)===4){
                msg(localestr('Не достатньо прав для позначення на знищення'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                return
            }
            setWndData({...wndData,start:-1,run:true})
            if(parseInt(wndData.oper)<5) setTimeout(()=>nextItem(),20)
            else setTimeout(()=>next10(),20)
        }
    }

    const nextItem=(d)=>{
        wndData=actions.getWndData()
        if(d){
            //console.log(d)
            //якщо офлайн зупинити
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);setWndData({...wndData,start:-1,run:false});return}
            //якщо помилка запитати чи продовжувати
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:localestr('Продовжити'),action:()=>{nextItem()}},{caption:localestr('Зупинити'),action:()=>{setWndData({...wndData,start:-1,run:false})}}]);return}
            //ОК; зняти галочку і змінити статус
            wndData.list[wndData.start].checked=false
            if(parseInt(wndData.oper)===1) {wndData.list[wndData.start].posted='1';wndData.list[wndData.start].marked='0'}
            else if(parseInt(wndData.oper)===2) {wndData.list[wndData.start].posted='0';wndData.list[wndData.start].marked='0'}
            else if(parseInt(wndData.oper)===3) {wndData.list[wndData.start].posted='0';wndData.list[wndData.start].marked='1'}
            else if(parseInt(wndData.oper)===4) {wndData.list[wndData.start].posted='0';wndData.list[wndData.start].marked='0'}
            setWndData({...wndData})
            //запустити наступну ітерацію
            nextItem()
        } else {
            //найти відмічену позицію
            let pos=wndData.start
            if(pos===undefined) pos=-1
            let finded=false
            for(let i=pos+1;i<wndData.list.length;i++){
                if(wndData.list[i].checked){
                    pos=i
                    finded=true
                    break
                }
            }
            if(!finded){
                setWndData({...wndData,start:-1,run:false})
                msg(localestr('Обробку закінчено!'),null,[{caption:'OK',action:()=>{}}])
                return
            }
            //запомнити позицію
            setWndData({...wndData,start:pos})
            //сформувати запит
            let obj_type=(wndData.list[pos].obj_type||'').substring(3)
            let req=''
            if(parseInt(wndData.oper)===1) req='action=post'+obj_type+'&data='+JSON.stringify({id:wndData.list[pos].id})
            else if(parseInt(wndData.oper)===2) req='action=unpost'+obj_type+'&data='+JSON.stringify({id:wndData.list[pos].id})
            else if(parseInt(wndData.oper)===3) req='action=rem'+obj_type+'&data='+JSON.stringify({id:wndData.list[pos].id,marked:'1'})
            else if(parseInt(wndData.oper)===4) req='action=rem'+obj_type+'&data='+JSON.stringify({id:wndData.list[pos].id,marked:'0'})

            setTimeout(()=>loaddata(req,undefined,nextItem,true),10)
        }
    }

    const next10=(d)=>{
        wndData=actions.getWndData()
        if(d){
            //якщо офлайн зупинити
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);setWndData({...wndData,start:-1,run:false});return}
            //якщо помилка запитати чи продовжувати
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:localestr('Продовжити'),action:()=>{nextItem()}},{caption:localestr('Зупинити'),action:()=>{setWndData({...wndData,start:-1,run:false})}}]);return}
            //ОК; зняти галочку і змінити статус
            for(let i=wndData.old_start||0;i<=wndData.start;i++) wndData.list[i].checked=false
            let printData=wndData.printData||[]
            wndData.printData=printData.concat(d.grp_data)
            setWndData({...wndData})
            //запустити наступну ітерацію
            next10()
        } else {
            //найти відмічену позицію
            let pos=wndData.start
            if(pos===undefined) pos=-1
            const old_start=pos+1
            let finded=false
            let pos_arr=[]
            for(let i=pos+1;i<wndData.list.length;i++){
                if(wndData.list[i].checked){
                    pos=i
                    pos_arr.push(wndData.list[pos].id)
                    finded=true
                    if(pos_arr.length>9) break
                }
            }
            if(!finded){
                if(wndData.printData){
                    if(wndData&&wndData.obj_type==='docCalculation'){
                        if(parseInt(wndData.oper)===5){
                            let item={arrData:[...wndData.printData],type:wndData.obj_type}
                            tabNew('docPrint',localestr('Калькуляція'),item)
                        } else if(parseInt(wndData.oper)===6){
                            let item={arrData:[...wndData.printData],type:wndData.obj_type,prn_type:1}
                            tabNew('docPrint',localestr('Технологічна карта'),item)
                        } else {
                            let item={arrData:[...wndData.printData],type:wndData.obj_type,prn_type:2}
                            tabNew('docPrint',localestr('Реєстр тех. карток'),item)
                        }
                    }
                }
                setTimeout(()=>tabClose(),100)
                //setWndData({...wndData,start:-1,run:false,old_start:0})
                //msg(localestr('Обробку закінчено!'),null,[{caption:'OK',action:()=>{}}])
                return
            }
            //запомнити позицію
            setWndData({...wndData,start:pos,old_start})
            //сформувати запит
            let obj_type=(wndData.list[pos].obj_type||'').substring(3)
            if(wndData&&wndData.obj_type) obj_type=(wndData.obj_type).substring(3)
            let req=''
            if(parseInt(wndData.oper)===5 || parseInt(wndData.oper)===6 || parseInt(wndData.oper)===7) req='action=doc'+obj_type+'&data='+JSON.stringify(pos_arr)
            //else if(parseInt(wndData.oper)===6) req='action=doc'+obj_type+'&data='+JSON.stringify(pos_arr)
            setTimeout(()=>loaddata(req,undefined,next10,true),10)
        }

    }

    function setFocus(el) {
        if (!el) return;
        
        // Прокручиваем элемент в видимую область
        el.scrollIntoView({ 
            behavior: 'smooth',  // плавная прокрутка
            block: 'center',     // элемент по центру экрана
            inline: 'nearest'    // минимальная горизонтальная прокрутка
        });
        
        // Устанавливаем фокус (с небольшой задержкой для плавной прокрутки)
        setTimeout(() => el.focus(), 600);
    }

    let cnt=0
    const items=wndData.list.map((item,idx)=>{
        if(item.checked) cnt++  //ще доробити щоб можна відкрити
        return (
        <tr key={idx} ref={el=>{if(wndData.start===idx) setFocus(el);return targetRef}}>
            <td key='a' style={{width:'22px',flexShrink:'0'}}><input type='checkbox' checked={item.checked===true} onChange={(e)=>{checkItem(idx,e.target.checked)}} /></td>
            <td key='b' style={{width:'140px',flexBasis:'140px',flexGrow:'140'}}>{itemToText({...item})}</td>
            <td key='c' style={{width:'105px',flexShrink:'0'}}>{(parseInt(item.marked)?localestr('Видалений'):'')+(parseInt(item.posted)?localestr('Проведений'):'')}</td>
        </tr>
        )
    })

    let size=48
    if(wndData.list) size=30+24*wndData.list.length
    const width2=110
    const label=wndData.run?'Зупинити':'Виконати'

    let selUserType=[{name:localestr('Провести / Перепровести'),value:1},{name:localestr('Зробити не проведеним'),value:2},{name:localestr('Позначити на видалення'),value:3},{name:localestr('Зняти позначку видалення'),value:4}]
    if(wndData&&wndData.obj_type==='docCalculation')
        selUserType.push({name:localestr('Друк калькуляційних карт'),value:5},{name:localestr('Друк технологічних карт'),value:6},{name:localestr('Друк реєстру тех. карток'),value:7})

    return(
        <div style={{display:'flex',flexDirection:'column', width:'100%',height:'100%'}}>
                <div className='toolBar no-print' style={{margin:'0 0 4px 0',alignItems:'center'}}>
                    <div style={{lineHeight:'30px',paddingLeft:'10px'}}>{localestr('Відібрано ')+cnt+localestr(' елементів')}&nbsp;</div>
                    <Edit Value={wndData.oper} typeVal={'selUserType'} setVal={chOper} userData={selUserType} style={{display:'inline-flex',width:width2+'px',maxWidth:width2*2+'px',boxSizing:'border-box',height:'24px',textAlign:'left',flexBasis:width2+'px',flexGrow:parseInt(width2),fontSize:'inherit',fontFamily:'inherit'}}/>
                    <div tabIndex='0' onClick={()=>{run()}} onKeyUp={(e)=>{if(e.key === 'Enter') run()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'97px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                        <img style={{width:'12px',height:'24px',padding:'2px',verticalAlign:'middle'}} src={icon+'#run'} alt={localestr(label)} />&nbsp;
                        {localestr(label)}
                    </div>
                    <div style={{flexGrow:'10'}}></div>
                </div>
                <div  style={{maxHeight:'100%',height:size+'px',minHeight:'50px'}}>
                    <table className='valueTable' style={{height:'calc(100% - 3px)',position:'relative'}}><thead><tr>
                        <th style={{width:'22px',flexShrink:'0'}}><input type='checkbox' checked={wndData.checked===true} onChange={(e)=>{checkAll(e.target.checked)}} /></th>
                        <th style={{width:'140px',flexBasis:'140px',flexGrow:'140'}}>{localestr('Документ')}</th>
                        <th style={{width:'120px',flexShrink:'0'}}>{localestr('Статус')}</th>
                    </tr></thead><tbody style={{height:'calc(100% - 27px)',position:'absolute'}}>{items}</tbody></table>
                </div>
                <div>
                    <table style={{overflow:'hidden'}}><tbody></tbody></table>                    
                </div>

        </div>

    )
}

export default ServGrpDoc